var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-header"> <button type="button"class="close"data-dismiss="modal"><span>&times;</span></button> <h3 class="modal-title"data-bind="text: options.title"></h3> </div> <div class="modal-body"> <p> <i class="fa fa-spinner fa-pulse"></i> <span data-bind="text: options.message"></span> </p> </div> <div class="modal-footer clearfix"> <button type="button"class="btn btn-default text-semibold"data-dismiss="modal"> Отмена </button> </div>';
}
return __p;
};
